export default __webpack_public_path__ + "static/media/maario.41c95a80.gif";